import { TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from '../app.constants';
import { LocalStorageService } from 'ngx-webstorage';
import { Injectable } from '@angular/core';
import { UserDTO } from '../entities/dto/user.dto';

@Injectable({ providedIn: 'root' })
export class TokenService {
  constructor(protected localStorageService: LocalStorageService) {}

  public getToken(): string {
    return this.localStorageService.retrieve(TOKEN_STORAGE_KEY);
  }

  public storeUser(user: UserDTO) {
    this.localStorageService.store(USER_STORAGE_KEY, user);
  }

  public storeToken(token: string) {
    this.localStorageService.store(TOKEN_STORAGE_KEY, token);
  }

  public clearToken() {
    this.localStorageService.clear(TOKEN_STORAGE_KEY);
  }

  public clearUser() {
    this.localStorageService.clear(USER_STORAGE_KEY);
  }

  public getUser(): UserDTO | undefined {
    const rawUser = this.localStorageService.retrieve(USER_STORAGE_KEY);
    if (!rawUser) {
      return undefined;
    }
    return UserDTO.hydrate(rawUser);
  }
}
